import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';

export type FormResult = { status: 'success' } | { status: 'failed'; message: string } | null;

/**
 * Outcome of a submit, announced politely: the green check-circle line of the password rules
 * (text/success) or the general error in text/brand. The region stays mounted while it is empty, so
 * screen readers pick up the change.
 */
export function FormResultMessage({
  result,
  success,
  className,
}: {
  result: FormResult;
  success: string;
  className?: string;
}) {
  return (
    <div role="status" className={className}>
      {result?.status === 'success' ? (
        <p className="dlz-body-s flex items-center gap-1.5 text-[#16753A]">
          <Icon name="check-circle" size={20} className="text-[#22A04B]" />
          {success}
        </p>
      ) : null}
      {result?.status === 'failed' ? (
        <p className="dlz-body-s whitespace-pre-line text-[#D7191F]">{result.message}</p>
      ) : null}
    </div>
  );
}
